/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { MySvgControllerService } from './services/my-svg-controller.service';
import { ListenpreiseControllerService } from './services/listenpreise-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    MySvgControllerService,
    ListenpreiseControllerService,
    ApiConfiguration
  ],
})
export class FuelCardShellListPricesModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<FuelCardShellListPricesModule> {
    return {
      ngModule: FuelCardShellListPricesModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: FuelCardShellListPricesModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('FuelCardShellListPricesModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
